
const trailingSlashRE = /\/?$/

export function isSameRoute (a, b) {
  if (!a || !b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash
    )
  } else {
    return false
  }
}

// function isObjectEqual (a = {}, b = {}) {
//   // handle null value #1566
//   if (!a || !b) return a === b
//   const aKeys = Object.keys(a)
//   const bKeys = Object.keys(b)
//   if (aKeys.length !== bKeys.length) {
//     return false
//   }
//   return aKeys.every(key => {
//     const aVal = a[key]
//     const bVal = b[key]
//     // check nested equality
//     if (typeof aVal === 'object' && typeof bVal === 'object') {
//       return isObjectEqual(aVal, bVal)
//     }
//     return String(aVal) === String(bVal)
//   })
// }

export function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (const key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}
